import React, { useMemo } from 'react';
import CustomBadge from 'components/ui/custom-badge';
import { ContractResponseDtoContractStatusEnum } from 'libs/pinnacle-sdk';
import { getContractStatusLabel } from 'utils';
import { useTranslation } from 'react-i18next';

interface ContractStatusIndicatorProps {
  status: ContractResponseDtoContractStatusEnum;
}

const ContractStatusIndicator: React.FC<ContractStatusIndicatorProps> = ({
  status,
}) => {
  const { t } = useTranslation();
  const config = useMemo(() => {
    switch (status) {
      case ContractResponseDtoContractStatusEnum.Pending:
        return {
          bg: 'bg-[#FEF0D8]',
          text: 'text-[#E48F00]',
          label: status,
        };
      case ContractResponseDtoContractStatusEnum.Quoted:
        return {
          bg: 'bg-[#EEDEFE]',
          text: 'text-[#8B37F5]',
          label: status,
        };
      case ContractResponseDtoContractStatusEnum.Bound:
        return {
          bg: 'bg-[#D6EBDD]',
          text: 'text-[#329B57]',
          label: status,
        };

      case ContractResponseDtoContractStatusEnum.Cancelled:
      case ContractResponseDtoContractStatusEnum.NotTakenUp:
        return {
          bg: 'bg-red-100',
          text: 'text-red-600',
          label: getContractStatusLabel(t)(status),
        };
      default:
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-600',
          label: status,
        };
    }
  }, [status]);

  return (
    <CustomBadge
      label={config.label}
      backgroundColor={config.bg}
      textColor={config.text}
    />
  );
};

export default ContractStatusIndicator;
